import BaseComponent from './BaseComponent';

const filterTemplate = (type, value, text) => `<div class="calendar__list__header__container__filters__filter" data-type="${type}" data-value="${value}">
                        <div class="calendar__list__header__container__filters__filter__button">
                            ${text} <svg class="calendar__list__header__container__filters__filter__button__svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 4L4 12" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M4 4L12 12" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </div>`

class CalendarList extends BaseComponent {
    constructor(el) {
        super(el);
        this.el = el;
        this.url = new URL(el.dataset.url);
        this.handleButtons();
        this.handleSearch(el);
        this.handlePagination(el);
        this.handleCheckboxes(el);
        this.handleFilters(el);
        this.handleClearFilters(el);
    }

    handleClearFilters(el) {
        document.body.addEventListener('click', (e) => {
            if (!e.target.classList.contains('calendar__list__header__container__filters__filter__remove__button') && !e.target.classList.contains('calendar__list__header__container__filters__filter__remove__button__svg') && !e.target.classList.contains('calendar__list__header__container__filters__filter__remove__button__svg') && !e.target.parentNode.classList.contains('calendar__list__header__container__filters__filter__remove__button__svg')) {
                return;
            }
            el.querySelector('.calendar__list__header__container__filters__filter__remove').classList.add('calendar__list__header__container__filters__filter__remove__hidden');
            const url = this.url;
            url.searchParams.delete('targetgroups[]');
            url.searchParams.delete('organisers[]');
            el.querySelectorAll('.calendar__list__header__container__filters__filter').forEach(e => e.remove());
            el.querySelectorAll('.calendar__list__header__container__buttons__button__children__checkbox input').forEach((item) => {
                item.checked = false;
            });
            this.callUrl(el, url);
        });
    }

    handleFilters(el) {
        document.body.addEventListener('click', (e) => {
            if (!e.target.classList.contains('calendar__list__header__container__filters__filter__button') && !e.target.classList.contains('calendar__list__header__container__filters__filter__button__svg') && !e.target.classList.contains('calendar__list__header__container__filters__filter__button__svg') && !e.target.parentNode.classList.contains('calendar__list__header__container__filters__filter__button__svg')) {
                return;
            }
            const selector = e.target.closest('.calendar__list__header__container__filters__filter');
            if (selector) {
                e.preventDefault();
                const url = this.url;
                selector.remove();
                url.searchParams.delete(selector.dataset.type, selector.dataset.value);
                const checkboxSelector = el.querySelector('[name="' + selector.dataset.type + '"][value="' + selector.dataset.value + '"');
                if (checkboxSelector) {
                    checkboxSelector.checked = false;
                }
                if (!el.querySelectorAll('.calendar__list__header__container__filters__filter').length) {
                    el.querySelector('.calendar__list__header__container__filters__filter__remove').classList.add('calendar__list__header__container__filters__filter__remove__hidden');
                }
                this.callUrl(el, url);
            }
        });
    }

    handleButtons() {
        this.el.querySelectorAll('.calendar__list__header__container__buttons__button').forEach((button) => {
            button.addEventListener('click', (e) => {
                if (e.target.classList.contains('calendar__list__header__container__buttons__button__children__checkbox') || e.target.classList.contains('calendar__list__header__container__buttons__button__children') || e.target.type == 'checkbox') {
                    return;
                }
                this.el.querySelectorAll('.calendar__list__header__container__buttons__button').forEach((item) => {
                    if (button == item) {
                        if (button.classList.contains('is-open')) {
                            button.classList.remove('is-open');
                            return;
                        }
                        button.classList.add('is-open');
                        return;
                    }
                    item.classList.remove('is-open');
                });

            });
        });
    }

    handleCheckboxes(el) {
        this.el.querySelectorAll('.calendar__list__header__container__buttons__button__children__checkbox input').forEach((checkbox) => {
            checkbox.addEventListener('click', (e) => {
                const url = this.url;
                if (e.target.checked) {
                    let textContent = e.target.parentElement.textContent.trim();
                    if (e.target.value.includes('-all')) {
                        textContent = checkbox.closest('.calendar__list__header__container__buttons__button__children__checkbox').dataset.title;
                    }
                    const removeEl = el.querySelector('.calendar__list__header__container__filters__filter__remove');
                    removeEl.classList.remove('calendar__list__header__container__filters__filter__remove__hidden');
                    removeEl.insertAdjacentHTML('beforeBegin', filterTemplate(e.target.name, e.target.value, textContent));
                    url.searchParams.append(e.target.name, e.target.value);
                    this.callUrl(el, url);
                } else {
                    url.searchParams.delete(e.target.name, e.target.value);
                    this.callUrl(el, url);
                    const selector = el.querySelector('[data-type="' + e.target.name + '"][data-value="' + e.target.value + '"');
                    if (selector) {
                        selector.remove();
                    }
                }
            });
        });
    }

    callUrl(el, url) {
        fetch(url)
        .then(function (response) {
            if (response.ok) {
                return response.text();
            }
            return Promise.reject(response);
        })
        .then(function (html) {
            const div = document.createElement('div');
            div.innerHTML = html;
            el.querySelector('.calendar__list__body__results').innerHTML = div.querySelector('.calendar-count').innerHTML;
            el.querySelector('.calendar__list__body__grid').innerHTML = div.querySelector('.calendar-list').innerHTML;
            el.querySelector('.calendar__list__footer__buttons').innerHTML = div.querySelector('.calendar-button').innerHTML;
        })
        .catch(function (error) {
            console.warn(error);
        });
    }

    handleSearch(el) {
        let typingTimer;
        let doneTypingInterval = 1200;
        let search = el.querySelector('.calendar__list__header__search input');
        if (!search) {
            return;
        }
        search.addEventListener('keyup', () => {
            const url = this.url;
            const $this = this;
            url.searchParams.set("search", search.value);
            clearTimeout(typingTimer);
            typingTimer = setTimeout(function () {
                $this.callUrl(el, url);
            }, doneTypingInterval);
        });
    }

    handlePagination(el) {
        document.body.addEventListener('click', (e) => {
            if (!e.target.closest('.calendar__list__footer__buttons button')) {
                return;
            }
            e.preventDefault();
            e.target.classList.add('is-active');
            const url = this.url;
            url.searchParams.set("offset", e.target.dataset.offset);
            fetch(this.url)
                .then(function (response) {
                    if (response.ok) {
                        return response.text();
                    }
                    return Promise.reject(response);
                })
                .then(function (html) {
                    url.searchParams.delete("offset");
                    const div = document.createElement('div');
                    div.innerHTML = html;
                    el.querySelector('.calendar__list__body__grid').insertAdjacentHTML('beforeend', div.querySelector('.calendar-list').innerHTML);
                    e.target.outerHTML = div.querySelector('.calendar-button').innerHTML;
                })
                .catch(function (error) {
                    console.warn(error);
                });
        });
    }
}

export default CalendarList;
